export { default } from './Modal';
export { default as Modal } from './Modal';
